//高危风险 LeakageRisk
import { useState, useEffect } from 'react'
import { Table, Spin, Card } from 'antd'
import HeaderBuilder from '@/components/TableBuilder/HeaderBuilder';
import SortOrFilter from '@/components/TableBuilder/SortOrFilter';
import { useNavigate } from 'react-router-dom'
import { RiskDisposeList_Get } from "@/services/leakage_risk"; // 引入Ajax
import local from '@/utils/local'
import './index.less'

export default function LeakageRisk () {
  const navigate = useNavigate()
  /**
   * data
   * */
  const [spinningLoading, setSpinningLoading] = useState(false);
  const [total, setTotal] = useState(0);
  const [List, setList] = useState();
  const [searchCriteria, setSearchCriteria] = useState({
    title: '',
    order: '',
    status: '',
    current: 1,
    pageSize: 10,
  });

  /**
   * methods
  * */
  // 巡检报告
  const getList = async (sift_data) => {
    setSpinningLoading(true)
    let res = await RiskDisposeList_Get({
      access_token: local.get('cruise_m350_token') || '',
      type: '2',
      types: '1',
      title: sift_data.title,
      order: sift_data.order,
      status: sift_data.status,
      page: sift_data.current,
      perpage: sift_data.pageSize,
    });
    setSpinningLoading(false)
    //console.log(res);
    if (res.ret === 200) {// eslint-disable-line
      if (res.data.items.length !== 0) {// eslint-disable-line
        res.data.items.forEach((item, index) => {
          item.key = index;
          item.c_list.forEach((val, ndx) => {
            val.key = ndx;
            // val.CompanyID = item.CompanyID;
            // val.pipe_name = item.pipe_name;
            val.statid = item.id;
          });
        });
      }
      let arr = []
      if (res.data.items && res.data.items.length > 0) {
        res.data?.items.forEach((item, index) => {
          let ch = []
          let obj = {}
          if (item.c_list && item.c_list.length > 0) {
            item?.c_list.forEach((ele, idx) => {
              let list = {
                ...ele,
                id: ele.statid,
                risks_count: ele.risks_total,
                pending_count: ele.pending_total,
                numKey: `${index}_${idx}`,
              }
              ch.push(list)
            })
            obj = {
              ...item,
              c_list: ch,
              numKey: index,
            }
            arr.push(obj)
          } else {
            arr.push({
              ...item,
              numKey: index,
            })
          }
        });
      }
      setList([...arr] || []);
      setTotal(res.data.total || 0);
    }
  };

  // 分页、排序、筛选变化时触发
  const handleTableChange = (newPagination, filters, sorter) => {
    let searchBefore = { ...searchCriteria };
    // 分页
    searchBefore.current = newPagination.current;
    searchBefore.pageSize = newPagination.pageSize;
    _searchCriteria({ ...searchBefore })
    getList(searchBefore) //加载列表
  };

  const columns = [
    {
      title: '管线/单元名称',
      // issearch: true,
      dataIndex: 'pipe_name',
    },
    {
      title: '总里程(km)',
      width: 150,
      dataIndex: 'pipe_len',
    },
    {
      title: '巡检起止',
      dataIndex: 'start_time',
      width: 200,
      // sorter: {
      //     compare: (a, b) => a.addtime - b.addtime,
      //     multiple: 1,
      // },
      render: (_, item, index) => {
        return (
          <div>
            <div style={{ display: (item.start_time) ? 'block' : 'none' }}>
              <span className='fSize14 opacity0_85 margR8'>{item.start_time.split(' ')[0]}</span>
              <span className='fSize14 opacity0_45'>{item.start_time.split(' ')[1]}</span>
            </div>
            <div style={{ display: (item.end_time) ? 'none' : 'block', paddingLeft: '50px' }}>
              <span className='coL0_85' style={{ color: (item.end_time) ? 'black' : 'red' }}>~</span>
            </div>
            <div className='' style={{ display: (item.end_time) ? 'block' : 'none' }}>
              <span className='fSize14 opacity0_85 margR8'>{item.end_time.split(' ')[0]}</span>
              <span className='fSize14 opacity0_45'>{item.end_time.split(' ')[1]}</span>
            </div>
          </div>
        );
      },
    },
    {
      title: '风险点',
      dataIndex: '',
      width: 180,
      render: (_, item, index) => {
        return (
          <div className='curPointer'>
            <div className="margL6 ">
              {item.risks_count}
            </div>
          </div>
        );
      },
    },
    {
      title: '待处理',
      dataIndex: '',
      width: 180,
      render: (_, item, index) => {
        return (
          <div>
            <div className='curPointer'>
              <div className="margL6"
                onClick={
                  () => {
                    if (item.pending_count === 0) {
                      return;
                    }
                    navigate('/leak_handle', { state: { companyId: item.CompanyID, statid: item.id, insIds: item.insIds, is_handle: true, total: item.pending_count, list: item } })
                  }
                }>
                <span style={{ color: (item.pending_count > 0) ? 'red' : 'white' }}>{item.pending_count}</span>
              </div>
            </div>
          </div>
        );
      },
    },
    {
      title: '已处理',
      dataIndex: '',
      width: 180,
      render: (_, item, index) => {
        return (
          <div>
            <div className='curPointer'>
              <div style={{ display: (item.risks_count > 0) ? 'block' : 'none' }}
                className="margL6 "
                onClick={
                  () => {
                    //如果待处理=风险点说明没有处理
                    if (item.pending_count === item.risks_count) {
                      return;
                    }
                    navigate('/leak_handle', { state: { companyId: item.CompanyID, statid: item.id, insIds: item.insIds, is_handle: false, total: item.risks_count, list: item } })
                  }
                }>
                <span style={{ color: (Number(item.risks_count) - Number(item.pending_count) > 0) ? '#177ddc' : 'white' }}>
                  {Number(item.risks_count) - Number(item.pending_count)}
                </span>
              </div>
            </div>
          </div>
        );
      },
    }
  ];

  //子表格
  const columns_c = [
    {
      issearch: true,
      dataIndex: 'line_name',
    },
    {
      width: 150,
      dataIndex: '',
    },
    {
      issearch: true,
      dataIndex: 'start_time',
      width: 200,
      render: (_, item, index) => {
        return (
          <div>
            <div style={{ display: (item.start_time) ? 'block' : 'none' }}>
              <span className='fSize14 opacity0_85 margR8'>{item.start_time.split(' ')[0]}</span>
              <span className='fSize14 opacity0_45'>{item.start_time.split(' ')[1]}</span>
            </div>
            <div style={{ display: (item.end_time) ? 'none' : 'block', paddingLeft: '50px' }}>
              <span className='coL0_85' style={{ color: (item.end_time) ? 'black' : 'red' }}>~</span>
            </div>
            <div className='' style={{ display: (item.end_time) ? 'block' : 'none' }}>
              <span className='fSize14 opacity0_85 margR8'>{item.end_time.split(' ')[0]}</span>
              <span className='fSize14 opacity0_45'>{item.end_time.split(' ')[1]}</span>
            </div>
          </div>
        );
      },
    },
    {
      title: '风险点',
      dataIndex: '',
      width: 180,
      render: (_, item, index) => {
        return (
          <div className='curPointer'>
            <div className="margL6 ">
              {item.risks_total}
            </div>
          </div>
        );
      },
    },
    {
      title: '待处理',
      dataIndex: '',
      width: 180,
      render: (_, item, index) => {
        return (
          <div>
            <div className='curPointer'>
              <div className="margL6"
                onClick={
                  () => {
                    if (item.pending_total === 0) {
                      return;
                    }
                    navigate('/leak_handle', { state: { companyId: item.CompanyID, statid: item.statid, insIds: item.insIds, is_handle: true, total: item.pending_total, list: item } })
                  }
                }>
                <span style={{ color: (item.pending_total > 0) ? 'red' : 'white' }}>{item.pending_total}</span>
              </div>
            </div>
          </div>
        );
      },
    },
    {
      title: '已处理',
      dataIndex: '',
      width: 180,
      render: (_, item, index) => {
        return (
          <div>
            <div className='curPointer'>
              <div className="margL6 "
                onClick={
                  () => {
                    //如果待处理=风险点说明没有处理
                    if (item.pending_total === item.risks_total) {
                      return;
                    }
                    navigate('/leak_handle', { state: { companyId: item.CompanyID, statid: item.statid, insIds: item.insIds, is_handle: false, total: item.risks_total, list: item } })
                  }
                }>
                <span style={{ color: (Number(item.risks_total) - Number(item.pending_total) > 0) ? '#177ddc' : 'white' }}>
                  {Number(item.risks_total) - Number(item.pending_total)}
                </span>
              </div>
            </div>
          </div>
        );
      },
    },
  ];

  useEffect(() => {
    getList(searchCriteria);
    // eslint-disable-next-line
  }, []);

  return (
    <Card style={{ background: 'black', overflowY: 'auto' }} >
      <div className="flex-col tablebackcol">
        {/* <div onClick={()=>{
                  navigate('/leak_handle', { state: { companyId: 1, statid:18, insIds: 18 } })
              }}>跳转</div> */}
        {/* <a id='a_report' download="巡检报告.docx" style={{ display: 'none' }}>
          查看
        </a> */}
        <Spin spinning={spinningLoading}>
          <div className='padd_24 flex-auto backcol'>
            <Table
              columns={columns}
              dataSource={List}
              rowKey='numKey'
              expandRowByClick={true}
              childrenColumnName='c_list'
              // expandable={{
              //   expandedRowRender: (record) => (
              //     <Table showHeader={false} pagination={false} columns={columns_c} dataSource={record.c_list} />
              //   )
              // }}
              pagination={{
                total: total,
                current: searchCriteria.current,
                pageSize: searchCriteria.pageSize,
                showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
                showQuickJumper: true,
                showSizeChanger: true,
              }}
              onChange={handleTableChange}
            />

          </div>
        </Spin>
      </div>
    </Card>
  )
}
